import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 no-underline"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={`${article.title} - 赤裸特工`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
            {article.categoryName}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {article.summary}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line text-xs"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line text-xs"></i>
              {article.readTime}
            </span>
          </div>
          <span className="text-xs text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            阅读更多 <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}